import { updates } from '@/mocks/homeData';

export default function UpdatesSection() {
  return (
    <section id="updates" className="py-14 md:py-20 bg-background-50">
      <div className="px-4 md:px-6 max-w-3xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-4xl font-black text-foreground-950 mb-3">
            最新动态
          </h2>
          <p className="text-foreground-500 text-sm md:text-base">
            吃瓜在线平台运营更新与重要通知
          </p>
        </div>

        <div className="relative pl-8 md:pl-10">
          <div className="absolute left-0 top-2 bottom-2 w-px bg-background-200"></div>

          <div className="space-y-8">
            {updates.map((item, i) => (
              <div key={i} className="relative">
                <div className="absolute -left-[35px] md:-left-[41px] top-1 w-3 h-3 rounded-full bg-primary-500 ring-4 ring-background-50"></div>
                <div className="flex items-center gap-3 mb-1.5">
                  <span className="text-xs font-medium text-foreground-400 whitespace-nowrap">
                    {item.date}
                  </span>
                  <span className="text-xs text-foreground-300 whitespace-nowrap">
                    {item.time}
                  </span>
                  {i === 0 && (
                    <span className="inline-block px-2 py-0.5 rounded-full bg-primary-100 text-primary-600 text-xs font-medium whitespace-nowrap">
                      最新
                    </span>
                  )}
                </div>
                <p className="text-sm md:text-base text-foreground-700 leading-relaxed">
                  {item.content}
                </p>
              </div>
            ))}
          </div>
        </div>

        <div className="text-center mt-8">
          <div className="inline-flex items-center gap-2 px-5 py-2.5 rounded-lg bg-background-100 border border-background-200/60 text-sm text-foreground-500 cursor-pointer">
            <i className="ri-more-line"></i>
            <span className="whitespace-nowrap">查看更多动态</span>
          </div>
        </div>
      </div>
    </section>
  );
}